import { NgClass, NgIf, NgSwitch, NgSwitchCase, NgSwitchDefault } from '@angular/common';
import { AfterViewInit, Component } from '@angular/core';
import { ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { MatTooltip } from '@angular/material/tooltip';
import { BullhornFieldType } from '../../data-rules-model';
import { IActionFieldMeta } from '../../meta-data.service';
import { BaseActionComponent } from '../base-action.component';

@Component({
  selector: 'app-action-replace',
  templateUrl: './replace.component.html',
  imports: [
    NgSwitchCase,
    NgSwitchDefault,
    NgSwitch,
    NgClass,
    ReactiveFormsModule,
    MatTooltip,
    NgIf,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatDatepicker
  ],
  styleUrls: ['../action.component.scss']
})
export class ReplaceComponent extends BaseActionComponent implements AfterViewInit {
  exceededDestinationCharCount = 0;

  ngAfterViewInit() {

    if (this.destinationTypeControl.value === BullhornFieldType.BOOLEAN &&
       typeof this.valueControl.value !== 'boolean' ) {
      this.valueControl.setValue(false);
    }

    if (!this.valueControl.value && typeof this.valueControl.value !== 'number') {
      this.valueControl.setValue(this.getDefaultValue(this.destinationTypeControl.value));
    }

    this.valueControl.valueChanges.subscribe(_ => this.valueControlValueChange());
    this.valueControlValueChange();

    setTimeout(() => {
      this.getMeta(this.destinationDescriptorControl.value)
        .subscribe(filteredMeta => {
          const selField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
          this.sourceControl.setValidators(null);
          this.destinationControl.setValidators(Validators.required);
          this.destinationControlValueChange(selField);
        });
    }, 0);
  }

  protected destinationControlValueChange(selectedField: IActionFieldMeta): void {

    if (!selectedField) {
      this.valueControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      this.destinationTypeControl.setValue(null);
      return;
    }

    if (this.destinationTypeControl.value !== selectedField.metaType)
      this.valueControl.setValue(this.getDefaultValue(selectedField.metaType));

    this.valueControl.setValidators(
      selectedField.metaType === BullhornFieldType.STRING || selectedField.metaType === BullhornFieldType.BOOLEAN
        ? null
        : Validators.required
    );

    this.destinationTypeControl.setValue(selectedField.metaType);

    this.checkExceededCharCount(selectedField);
  }

  private getDefaultValue(type: string): any {
    switch (type) {
      case 'BOOLEAN':
        return false;
      case 'STRING':
        return '';
      default:
        return null;
    }
  }

  private valueControlValueChange(): void {
    this.getMeta(this.destinationDescriptorControl.value)
      .subscribe(filteredMeta => {
        const dstField = filteredMeta.find(fm => fm.fieldName === this.destinationControl.value);
        this.checkExceededCharCount(dstField);
      });
  }

  private checkExceededCharCount(dstField: IActionFieldMeta): void {
    this.exceededDestinationCharCount = 0;
    if (!dstField || dstField.metaType !== BullhornFieldType.STRING)
      return;

    const userInputCharCount = this.valueControl.value ? this.valueControl.value.length : 0;
    this.exceededDestinationCharCount = userInputCharCount - dstField.maxLength;
  }
}
